import CheckoutPage from '../pages/CheckoutPage/CheckoutPage';
import CoverableDetailsPage from '../pages/CoverableDetailsPage/CoverableDetailsPage';
import ReceiptPage from '../pages/ReceiptPage/ReceiptPage';
import ShoppingBasketPage from '../pages/ShoppingBasketPage/ShoppingBasketPage';
import ShoppingBasketSummaryPage from '../pages/ShoppingBasketSummaryPage/ShoppingBasketSummaryPage';
import CoverableInformationPage from '../pages/CoverableInformationPage/CoverableInformationPage';
import ClaimsHistoryPage from '../pages/ClaimsHistoryPage/ClaimsHistoryPage';
import CustomerIdentificationPage from '../pages/CustomerIdentificationPage/CustomerIdentificationPage';
import CprQuestionPage from '../pages/CprQuestionPage/CprQuestionPage';
import CoveragePackagePage from '../pages/CoveragePackagePage/CoveragePackagePage';
import AdditionalCoveragePage from '../pages/AdditionalCoveragePage/AdditionalCoveragePage';
import ProductSelectorPage from '../pages/ProductSelectorPage/ProductSelectorPage';
import QuoteExpiredContent from '../pages/QuoteExpiredPage/components/QuoteExpiredContent';
import OpcEntryPage from '../pages/OpcEntryPage/OpcEntryPage';
import AdjustDetailsPage from '../pages/AdjustDetailsPage/AdjustDetailsPage';
import LandingPage from '../pages/LandingPage/LandingPage';
import MitIdLoginPage from '../pages/MitIdLoginPage/MitIdLoginPage';
import AdditionalInformationPage from '../pages/AdditionalInformationPage/AdditionalInformationPage';
import PostLoginQuestionsPage from '../pages/PostLoginQuestionsPage/PostLoginQuestionsPage';
import ResumeOnsaPage from '../pages/ResumeOnsaPage/ResumeOnsaPage';

type WizardPageComponent = () => React.JSX.Element;

const wizardPages = [
    {
        name: 'ProductSelectorPage',
        Component: ProductSelectorPage
    },
    {
        name: 'CoverableInformationPage',
        Component: CoverableInformationPage
    },
    {
        name: 'ClaimsHistoryPage',
        Component: ClaimsHistoryPage
    },
    {
        name: 'AdditionalInformationPage',
        Component: AdditionalInformationPage
    },
    {
        name: 'CustomerIdentificationPage',
        Component: CustomerIdentificationPage
    },
    {
        name: 'CprQuestionPage',
        Component: CprQuestionPage
    },
    {
        name: 'PostLoginQuestionsPage',
        Component: PostLoginQuestionsPage
    },
    {
        name: 'CoveragePackagePage',
        Component: CoveragePackagePage
    },
    {
        name: 'AdditionalCoveragePage',
        Component: AdditionalCoveragePage
    },
    {
        name: 'MitIdLoginPage',
        Component: MitIdLoginPage
    },
    {
        name: 'LandingPage',
        Component: LandingPage
    },
    {
        name: 'ShoppingBasketPage',
        Component: ShoppingBasketPage
    },
    {
        name: 'CoverableDetailsPage',
        Component: CoverableDetailsPage
    },
    {
        name: 'AdjustDetailsPage',
        Component: AdjustDetailsPage
    },
    {
        name: 'ShoppingBasketSummaryPage',
        Component: ShoppingBasketSummaryPage
    },
    {
        name: 'CheckoutPage',
        Component: CheckoutPage
    },
    {
        name: 'ReceiptPage',
        Component: ReceiptPage
    },
    {
        name: 'ExpiredPage',
        Component: QuoteExpiredContent
    },
    {
        name: 'OpcEntryPage',
        Component: OpcEntryPage
    },
    {
        name: 'ResumeOnsaPage',
        Component: ResumeOnsaPage
    }
] as const;

type WizardPageComponentName = (typeof wizardPages)[number]['name'];

const pageIndex = (pageName: WizardPageComponentName): number =>
    wizardPages.findIndex((page) => page.name === pageName) + 1;

export { wizardPages, pageIndex };
export type { WizardPageComponentName, WizardPageComponent };
